// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-target-dialog-body {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #000;
    margin-top: 1px solid #e1e1e1;
    padding: 13px 26px;
}

.delete-target-dialog-footer {
    align-self: flex-end;
    display: flex;
    justify-content: flex-end;
    column-gap: 16px;
    padding: 16px 24px;
}

.delete-target-dialog-button {
    background-color: rgb(255, 255, 255);
    border: 1px solid #bdbdbd;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 32px;
    color: #000;
    transition: background-color 100ms ease;
}

.delete-target-dialog-button:hover {
    background-color: rgb(255, 255, 255, 0.6);
}

.delete-target-dialog-button-danger {
    background-color: rgb(215, 108, 97, 1);
    color: #ffffff;
    border: none;
}

.delete-target-dialog-button-danger:hover {
    background-color: rgb(215, 108, 97, 0.8);
}

.delete-target-dialog-title-wrapper {
    font-size: 24px;
    display: flex;
    align-items: center;
    padding: 19px 26px 13px 26px;
    justify-content: space-between;
}

.delete-target-dialog-title {
    display: flex;
    column-gap: 16px;
    margin: 0;
    align-items: center;
}

.delete-target-dialog-cross-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    border: none;
    outline: none;
    background-color: transparent;
}

.delete-target-dialog {
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    border: none;
    padding: 0;
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.1);
}

.delete-target-dialog-divider {
    height: 1px;
    width: 100%;
    background: #e1e1e1;
}
`, "",{"version":3,"sources":["webpack://./client/components/product-collection/footer/components/left-side/delete-target-dialog/delete-target-dialog.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,uCAAuC;AAC3C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,sCAAsC;IACtC,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".delete-target-dialog-body {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    color: #000;\n    margin-top: 1px solid #e1e1e1;\n    padding: 13px 26px;\n}\n\n.delete-target-dialog-footer {\n    align-self: flex-end;\n    display: flex;\n    justify-content: flex-end;\n    column-gap: 16px;\n    padding: 16px 24px;\n}\n\n.delete-target-dialog-button {\n    background-color: rgb(255, 255, 255);\n    border: 1px solid #bdbdbd;\n    border-radius: 24px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 8px 32px;\n    color: #000;\n    transition: background-color 100ms ease;\n}\n\n.delete-target-dialog-button:hover {\n    background-color: rgb(255, 255, 255, 0.6);\n}\n\n.delete-target-dialog-button-danger {\n    background-color: rgb(215, 108, 97, 1);\n    color: #ffffff;\n    border: none;\n}\n\n.delete-target-dialog-button-danger:hover {\n    background-color: rgb(215, 108, 97, 0.8);\n}\n\n.delete-target-dialog-title-wrapper {\n    font-size: 24px;\n    display: flex;\n    align-items: center;\n    padding: 19px 26px 13px 26px;\n    justify-content: space-between;\n}\n\n.delete-target-dialog-title {\n    display: flex;\n    column-gap: 16px;\n    margin: 0;\n    align-items: center;\n}\n\n.delete-target-dialog-cross-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin: 0;\n    border: none;\n    outline: none;\n    background-color: transparent;\n}\n\n.delete-target-dialog {\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    border: none;\n    padding: 0;\n    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.1);\n}\n\n.delete-target-dialog-divider {\n    height: 1px;\n    width: 100%;\n    background: #e1e1e1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
